import React from 'react';

const OpenClaude = () => (
  <article className="news-article-body">
    <p className="news-lead">
      In 2025, Anthropic signalled a meaningful pivot toward the open-source community — not by
      releasing Claude's weights, but by opening access through dedicated programmes and releasing
      key developer tooling as open source. The <strong>Claude for Open Source</strong> programme
      and the open-sourcing of <strong>Claude Code</strong> represent Anthropic's bid to embed
      Claude into the developer ecosystem.
    </p>

    <h2>Claude for Open Source Programme</h2>
    <p>
      Launched in mid-2025, the <em>Claude for Open Source</em> programme offers eligible
      maintainers and core contributors of public GitHub repositories complimentary access to
      <strong> Claude Max 20x</strong> for six months at no cost. The initiative targets:
    </p>
    <ul>
      <li>Repositories with <strong>5,000+ stars</strong> or <strong>1M+ monthly npm downloads</strong></li>
      <li>Projects with significant ecosystem impact (OSS infrastructure, frameworks, tools)</li>
      <li>Up to <strong>10,000 approved recipients</strong> globally</li>
    </ul>
    <p>
      The programme is Anthropic's counter-offer to the open-weight models from Meta (Llama),
      Alibaba (Qwen), and Mistral — providing frontier performance to OSS developers without
      releasing model weights.
    </p>

    <h2>Claude Code as Open Source</h2>
    <p>
      Anthropic released the <strong>Claude Code</strong> agentic coding tool as open-source
      software on GitHub. Claude Code runs in the terminal and enables developers to:
    </p>
    <ul>
      <li>Navigate and edit codebases using natural language</li>
      <li>Execute tests, run build scripts, and manage git workflows</li>
      <li>Orchestrate multi-step coding tasks with agentic autonomy</li>
      <li>Integrate into CI/CD pipelines and IDEs</li>
    </ul>
    <p>
      Opening Claude Code's interface (though not the underlying model weights) allowed the
      developer community to contribute extensions, IDE bridges, and custom tool integrations.
    </p>

    <h2>Claude Models — 2025 Lineup</h2>
    <div className="news-specs-grid">
      <div className="news-spec-item">
        <span className="news-spec-label">Claude Opus 4.6</span>
        <span className="news-spec-value">Most intelligent — optimised for agents and complex coding</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">Claude Sonnet 4.6</span>
        <span className="news-spec-value">Balanced speed and intelligence — production API default</span>
      </div>
      <div className="news-spec-item">
        <span className="news-spec-label">Claude Haiku 4.5</span>
        <span className="news-spec-value">Fastest and most cost-efficient — high-volume tasks</span>
      </div>
    </div>

    <h2>The Strategic Context</h2>
    <p>
      Anthropic occupies an unusual position: a safety-focused lab with a commercial imperative.
      The Claude for Open Source programme and Claude Code release signal a recognition that
      developer adoption requires meeting the community where it is — in open-source toolchains —
      without compromising Anthropic's core model as a commercial and safety-controlled asset.
    </p>

    <div className="news-insight-box">
      <h3>Key Takeaway</h3>
      <p>
        Anthropic's open-source strategy is "ecosystem open, model closed." By embedding Claude
        into OSS workflows and giving power users free access, they build lock-in through
        developer habit rather than open weights — a model distinct from both OpenAI's API-only
        approach and Meta's fully open weight releases.
      </p>
    </div>
  </article>
);

export default OpenClaude;
